import React from 'react'
import PropTypes from 'prop-types'
import Favoritable from '../favoriteButton/Favoritable'
import './FavoriteDeleteUndo.scss'

const FavoriteDeleteUndo = ({ favorite, onAdded }) => {
  return (
    <Favoritable planEntry={favorite.planEntry}>
      {({ addToFavorites }) => {
        return (
          <div className='FavoriteDeleteUndo'>
            <div className='FavoriteDeleteUndo__action'>
              <span>You&apos;ve removed {favorite.planEntry.title}</span>
              <a
                className='FavoriteDeleteUndo__undoBtn'
                onClick={() => {
                  addToFavorites(onAdded, {
                    orderby: favorite.orderby
                  })
                }}
              >
                Undo
              </a>
            </div>
          </div>
        )
      }}
    </Favoritable>
  )
}

FavoriteDeleteUndo.propTypes = {
  favorite: PropTypes.object,
  onAdded: PropTypes.func
}

export default FavoriteDeleteUndo
